











































































































import {Component, Vue, Watch} from 'vue-property-decorator'
import {$} from '@/facade'
import {NeoHelper} from '@/helpers/NeoHelper'
import {OrbitSetupStep} from '@/enums/OrbitSetupStep'
import {getN3InvocationBuilder} from '@/model/wallets/invocationsBuilder'
import OrbitLoadingTransactionStep from '@/components/orbit/OrbitLoadingTransactionStep.vue'
import OrbitInsufficientGasStep from '@/components/orbit/OrbitInsufficientGasStep.vue'
import OrbitUnexpectedErrorStep from '@/components/orbit/OrbitUnexpectedErrorStep.vue'
import OrbitRejectedByTheUserStep from '@/components/orbit/OrbitRejectedByTheUserStep.vue'
import OrbitSuccessStep from '@/components/orbit/OrbitSuccessStep.vue'
import OrbitSetupFormStep from '@/components/orbit/OrbitSetupFormStep.vue'
import {OrbitHelper} from '@/helpers/OrbitHelper'

@Component({
  computed: {
    OrbitSetupRoundStep() {
      return OrbitSetupStep
    },
  },
  components: {
    OrbitSetupFormStep,
    OrbitSuccessStep,
    OrbitLoadingTransactionStep,
    OrbitInsufficientGasStep,
    OrbitUnexpectedErrorStep,
    OrbitRejectedByTheUserStep,
  },
})
export default class OrbitSetupModal extends Vue {
  currentStep: OrbitSetupStep = OrbitSetupStep.FORM
  transactionHash: string | null = null

  mounted() {
    this.populateResources()
  }

  async populateResources() {
    await OrbitHelper.checkWalletPermissions().catch(() => {
      this.closeModal()
    })
  }

  async confirmSetup(durations: {
    roundDurationMs: string
    claimDurationMs: string
    distributionDurationMs: string
    lockoutDurationMs: string
  }) {
    try {
      this.currentStep = OrbitSetupStep.WAITING_SIGNATURE

      const n3InvocationBuilder = getN3InvocationBuilder()
      const setupOrbitInvocationBuilder = n3InvocationBuilder.setupOrbitInvocation(
        {
          roundDuration: durations.roundDurationMs,
          claimDuration: durations.claimDurationMs,
          distributionDuration: durations.distributionDurationMs,
          lockoutDuration: durations.lockoutDurationMs,
        }
      )

      this.transactionHash = await $.walletAdapter.invokeN3Wallet(
        setupOrbitInvocationBuilder
      )
      if (!this.transactionHash) throw new Error('Undefined transaction')

      this.currentStep = OrbitSetupStep.VALIDATING_TRANSACTION

      const isTransactionValid = await NeoHelper.validateTransaction(
        this.transactionHash
      )
      if (!isTransactionValid) throw new Error('Failed to verify transaction')

      this.currentStep = OrbitSetupStep.FINISHED

      $.toast.success('system.success.persist')
    } catch (error) {
      this.threatError(error)
    }

    this.closeModal()
  }

  onClickCloseModal() {
    if (
      this.currentStep === OrbitSetupStep.WAITING_SIGNATURE ||
      this.currentStep === OrbitSetupStep.VALIDATING_TRANSACTION
    ) {
      return
    }

    this.closeModal()
  }

  closeModal() {
    this.currentStep = OrbitSetupStep.WAITING_SIGNATURE
    this.$emit('close')
  }

  @Watch('$store.state.walletAdapter.n3.address')
  async onN3AddressChange(address: string | null) {
    if (!address) {
      this.closeModal()
      return
    }

    await OrbitHelper.checkWalletPermissions().catch(() => {
      this.closeModal()
    })
  }

  private threatError(error: any) {
    console.error(error)

    if (
      String(error.message).includes('cannot change period during active round')
    ) {
      $.toast.error('You cannot change period during active round.')
    }

    const isNeonWalletRejected =
      error.message && String(error.message).includes('rejected by the user')

    const isNeoLineWalletRejected =
      error.description &&
      error.description === 'The user cancels, or refuses the dapps request'

    if (isNeonWalletRejected || isNeoLineWalletRejected) {
      this.currentStep = OrbitSetupStep.REJECTED_BY_THE_USER
      return
    }

    const hasInsufficientFunds =
      error.message && String(error.message).includes('insufficient funds')
    if (hasInsufficientFunds) {
      this.currentStep = OrbitSetupStep.INSUFFICIENT_GAS
      return
    }

    this.currentStep = OrbitSetupStep.UNKNOWN_ERROR
  }
}
